// MODEL : instance of Domain
//
//every time user clicks on domain
// a new instance of this is created and initialized.
define('app/dashboard/panels/DashboardPanel',['require','glu/itemView','glu/store','glu/$','glu/dialog','app/dashboard/dialogs/CreateReportDialogView','app/dashboard/dialogs/CreateMonitorDialogView','app/dashboard/widgets/KpiReportDashboardItemView','app/dashboard/widgets/DonutChartDashboardItemView','app/dashboard/widgets/Top10ReportDashboardItemView','app/dashboard/widgets/LineChartDashboardItemView','app/dashboard/widgets/BarChartDashboardItemView','app/dashboard/widgets/StackedBarChartDashboardItemView','app/dashboard/widgets/StackedBarChartLargeDashboardItemView','app/dashboard/widgets/ScatterPlotDashboardItemView','app/dashboard/widgets/PieChartDashboardItemView','app/dashboard/widgets/TableReportDashboardItemView','app/dashboard/DashboardEntitiesGridView','app/dashboard/DashboardMonitorsGridView','glu/util','app/app','hbs!./DashboardPanel.hbs'],function(require) {

	'use strict';
	var ItemView = require('glu/itemView'),
		store = require('glu/store'),
		$ = require('glu/$'),
		dialog = require('glu/dialog'),
		CreateReportDialogView = require('app/dashboard/dialogs/CreateReportDialogView'),
		CreateMonitorDialogView = require('app/dashboard/dialogs/CreateMonitorDialogView'),
		KpiReportDashboardItemView = require('app/dashboard/widgets/KpiReportDashboardItemView'),
		DonutChartDashboardItemView = require('app/dashboard/widgets/DonutChartDashboardItemView'),
		Top10ReportDashboardItemView = require('app/dashboard/widgets/Top10ReportDashboardItemView'),
		LineChartDashboardItemView = require('app/dashboard/widgets/LineChartDashboardItemView'),
		BarChartDashboardItemView = require('app/dashboard/widgets/BarChartDashboardItemView'),
		StackedBarChartDashboardItemView = require('app/dashboard/widgets/StackedBarChartDashboardItemView'),
		StackedBarChartLargeDashboardItemView = require('app/dashboard/widgets/StackedBarChartLargeDashboardItemView'),
		ScatterPlotDashboardItemView = require('app/dashboard/widgets/ScatterPlotDashboardItemView'),
		PieChartDashboardItemView = require('app/dashboard/widgets/PieChartDashboardItemView'),
		TableReportDashboardItemView = require('app/dashboard/widgets/TableReportDashboardItemView'),
		DashboardEntitiesGridView = require('app/dashboard/DashboardEntitiesGridView'),
		DashboardMonitorsGridView = require('app/dashboard/DashboardMonitorsGridView'),
		_ = require('glu/util'),
		App = require('app/app');

	return ItemView.extend({
		template: require('hbs!./DashboardPanel.hbs'),
		className: 'dashboard-panel dashboard-tabs-container',

		attributes: {
			role: 'tab-panel'
		},

		ui: {
			myTab: '#dashboard-tab-my',
			myWidgetsTab: '#dashboard-tab-my-widgets',
			myMonitorsTab: '#dashboard-tab-my-monitors',
			tab: '[data-toggle="tab"]',
			myWidgetsContainer: '#widget-sections-container'
		},

		events: {
			'click @ui.tab': 'handleTabSelection',
			'click .toggle-description': 'toggleDescription',
			'click .add-report-button': 'createReport',
			'click .add-monitor-button': 'createMonitor',
			'click .add-widget-report-button': 'createWidget'
		},

		widgets: [],

		onMasterFilterChange: function() {
			var self = this,
				filter = this.model.getMasterFilter();

			_.each(this.reportsToRefreshOnFilterChange, function(report) {
				self.runReportWithSubstituteFilter(report, filter);
			});
		},

		runReportWithSubstituteFilter: function(report, filter) {
			var self = this;

			if (report && report.isRunnable() && filter && filter.isValid()) {
				report.set('isLoading', true);

				// ONLY run the report if there is a valid filter, since a date should always be set
				if (filter && filter.isValid()) {
					var domain = report.get('domain'),
						defaultMasterFilter = domain.defaultMasterFilter(),
						currentFilterValues = self.model.getMasterFilter().get('values'),
						operator = self.model.getMasterFilter().get('operator');

					defaultMasterFilter.set('values', currentFilterValues);
					defaultMasterFilter.set('operator', operator);
					domain.setMasterFilter(defaultMasterFilter);

					report.runWithSubstituteFilter(defaultMasterFilter);
				}
			}
		},

		killEventListeners: function() {
			this.undelegateEvents();
			this.stopListening();
			_.each(this.widgets, function(w) {
				w.close();
			});
		},

		getNumberWidgets: function() {
			return this.model.reportCollection().filter(function(report) {
				return report.isWidget();
			}).length;
		},

		onRender: function() {
			var self = this;
			var dashboard = this.model;

			this.reportsToRefreshOnFilterChange = [];
			// Make sure our collections is up to date
			$.when(dashboard.reportCollection().fetch(), dashboard.monitorCollection().fetch()).then(function() {
				self.generatePanel();

				// do not show 'Add Widget' panel if the dashboard is not user's
				if (self.getNumberWidgets() === 0 && dashboard.get('owner') === App.user.getUsername()) {
					$('#dashboardtab-my-widgets').addClass('empty');
				} else {
					$('#dashboardtab-my-widgets').removeClass('empty');
				}
			});
		},

		toggleDescription: function(e) {
			var self = this;

			e.preventDefault();

			if (self.model.get('description') && self.model.get('description').length > 0) {
				self.$el.find('.description').fadeToggle('fast');
			}
		},

		generatePanel: _.debounce(function() {
			var self = this;
			var dashboard = this.model;

			//add views
			self.addViews();

			//add all the widgets
			this.$('.dashboardtab-my-widgets-container').empty();
			dashboard.reportCollection().each(self.displayReport, self);

			self.getSavedTabSelection();

			// allow widgets to be rearranged within their container.
			self.enableDragAndDrop();

			// resort the widgets on the my widgets tab using saved preferences (if present).
			self.sortWidgets();

			// disable the add report/widget panel if needed
			self.toggleDashboardControls();

			// Set event listeners
			self.setEventListeners();
		}, 300),

		setEventListeners: function() {
			var self = this;

			//listen for filter changes
			self.listenTo(self.model, 'masterfilterchange', self.onMasterFilterChange);
		},

		toggleDashboardControls: function() {
			if (this.model.get('dashboardType') === 'FIXED') {
				this.$el.parent().addClass('fixed-dashboard');
			} else {
				this.$el.parent().removeClass('fixed-dashboard');
			}

			if (this.model.get('owner') !== App.user.getUsername()) {
				this.$('.add-widget-button').hide();
			}
		},

		/**
		 * Allow widgets to be rearranged within their container.  Widgets cannot be moved into different containers.
		 */
		enableDragAndDrop: function() {
			var lists = this.$('.dashboardtab-my-widgets-container');
			var self = this;

			lists.sortable({
				tolerance: 'pointer',
				items: '.dashboard-item',
				over: function(evt, ui) {
					// set the look and feel of the draggable container
					self.$(ui.item).parent().addClass('drag-active');
				},

				stop: function(evt, ui) {
					// revert the look and feel of the draggable container
					self.$(ui.item).parent().removeClass('drag-active');

					self.saveWidgetOrder(this);
				}
			});
		},

		addViews: function() {
			//this view does not know when each of the 'DashboardEntitiesGridView' will be empty
			//because they are designed to work independently, and the specific "empty" logics
			//should not be a concern for this view

			//'my reports' tab
			this.gridMy = new DashboardEntitiesGridView({
				model: this.model,
				items: this.model.reportCollection(),
				itemType: 'report',
				filter: this.gridFilterMyReports
			});
			this.$('#dashboard-tab-my').find('.entities-grid-container').empty();
			this.$('#dashboard-tab-my').find('.entities-grid-container').append(this.gridMy.render().el);

			//'my monitors' tab
			this.gridMonitors = new DashboardMonitorsGridView({
				model: this.model,
				items: this.model.monitorCollection(),
				itemType: 'monitor'
			});
			this.$('#dashboardtab-my-monitors').find('.entities-grid-container').empty();
			this.$('#dashboardtab-my-monitors').find('.entities-grid-container').append(this.gridMonitors.render().el);
		},

		gridFilterMyReports: function(entity) {
			// filter out spd reports and widgets
			if (entity.isSpdReport() || entity.isWidget()) {
				return false;
			}
			return true;
		},

		gridFilterOthersReports: function(entity) {
			if (entity.isSpdReport()) {
				return false;
			}
			if (entity.get('isPrivate') === true) {
				return false;
			}
			return !entity.isOwner();
		},

		onClose: function() {
			_.each(this.widgets, function(w) {
				w.close();
			});
		},

		displayReport: function(report) {
			var self = this;
			switch (report.getWidgetType()) {
				case 'KPI':
					this.displayKpiWidget(report);
					break;
				case 'DONUT':
					this.displayDonutWidget(report);
					break;
				case 'TOP10':
					this.displayTop10Widget(report);
					break;
				case 'LINECHART':
					this.displayLineChartWidget(report);
					break;
				case 'BARCHART':
					this.displayBarChartWidget(report);
					break;
				case 'SCATTERPLOT':
					this.displayScatterPlotWidget(report);
					break;
				case 'STACKEDBARCHART':
					if (self.model.get('layout') === 'CONVERSION') {
						this.displayStackedBarChartLargeWidget(report);
					} else {
						this.displayStackedBarChartWidget(report);
					}
					break;
				case 'PIECHART':
					this.displayPieChartWidget(report);
					break;
				case 'TABLE':
					this.displayTableWidget(report);
					break;
			}
		},

		/**
		 * Display a mini scatter plot widget.
		 */
		displayScatterPlotWidget: function(report) {
			var view = new ScatterPlotDashboardItemView({
				model: report
			});
			this.addWidget(view, report, '.dashboardtab-my-widgets-container');
			this.reportsToRefreshOnFilterChange.push(report);
			this.runReportWithSubstituteFilter(report, this.model.getMasterFilter());
			this.listenTo(this, 'close', view.close);
		},

		/**
		 * Display a mini pie chart widget.
		 */
		displayPieChartWidget: function(report) {
			var view = new PieChartDashboardItemView({
				model: report
			});
			this.addWidget(view, report, '.dashboardtab-my-widgets-container');
			this.reportsToRefreshOnFilterChange.push(report);
			this.runReportWithSubstituteFilter(report, this.model.getMasterFilter());
			this.listenTo(this, 'close', view.close);
		},

		/**
		 * Display a mini line chart widget.
		 */
		displayLineChartWidget: function(report) {
			var view = new LineChartDashboardItemView({
				model: report
			});
			this.addWidget(view, report, '.dashboardtab-my-widgets-container');
			this.reportsToRefreshOnFilterChange.push(report);
			this.runReportWithSubstituteFilter(report, this.model.getMasterFilter());
			this.listenTo(this, 'close', view.close);
		},

		/**
		 * Display a mini bar chart widget.
		 */
		displayBarChartWidget: function(report) {
			var view = new BarChartDashboardItemView({
				model: report
			});
			this.addWidget(view, report, '.dashboardtab-my-widgets-container');
			this.reportsToRefreshOnFilterChange.push(report);
			this.runReportWithSubstituteFilter(report, this.model.getMasterFilter());
			this.listenTo(this, 'close', view.close);
		},

		/**
		 * Display a mini stacked bar chart widget.
		 */
		displayStackedBarChartWidget: function(report) {
			var view = new StackedBarChartDashboardItemView({
				model: report
			});
			this.addWidget(view, report, '.dashboardtab-my-widgets-container');
			this.reportsToRefreshOnFilterChange.push(report);
			this.runReportWithSubstituteFilter(report, this.model.getMasterFilter());
			this.listenTo(this, 'close', view.close);
		},

		displayStackedBarChartLargeWidget: function(report) {
			var view = new StackedBarChartLargeDashboardItemView({
				model: report
			});
			this.addWidget(view, report, '.chart-widget-container');
			this.reportsToRefreshOnFilterChange.push(report);
			this.runReportWithSubstituteFilter(report, this.model.getMasterFilter());
			this.listenTo(this, 'close', view.close);
		},

		displayDonutWidget: function(report) {
			var view = new DonutChartDashboardItemView({
				model: report
			});
			this.addWidget(view, report, '.dashboardtab-my-widgets-container');
			this.reportsToRefreshOnFilterChange.push(report);
			this.runReportWithSubstituteFilter(report, this.model.getMasterFilter());
			this.listenTo(this, 'close', view.close);
		},

		displayKpiWidget: function(report) {
			var view = new KpiReportDashboardItemView({
				model: report
			});
			this.addWidget(view, report, '.dashboardtab-my-widgets-container');
			this.reportsToRefreshOnFilterChange.push(report);
			this.runReportWithSubstituteFilter(report, this.model.getMasterFilter());
			this.listenTo(this, 'close', view.close);
		},

		displayTop10Widget: function(report) {
			var view = new Top10ReportDashboardItemView({
				model: report
			});
			this.addWidget(view, report, '.dashboardtab-my-widgets-container');
			this.reportsToRefreshOnFilterChange.push(report);
			this.runReportWithSubstituteFilter(report, this.model.getMasterFilter());
			this.listenTo(this, 'close', view.close);
		},

		displayTableWidget: function(report) {
			var view = new TableReportDashboardItemView({
				model: report
			});
			this.addWidget(view, report, '.dashboardtab-my-widgets-container');
			this.reportsToRefreshOnFilterChange.push(report);
			this.runReportWithSubstituteFilter(report, this.model.getMasterFilter());
			this.listenTo(this, 'close', view.close);
		},

		addWidget: function(view, model, selector) {
			var tab = this.$('#dashboard-tab-my-widgets');
			var $renderedEl = view.render().$el;
			$renderedEl.attr('data-qa', model.get('name'));
			tab.find(selector).append($renderedEl);
			this.widgets.push(view);
		},

		/**
		 * Handle the click of a tab.
		 */
		handleTabSelection: function(e) {
			var target = $(e.currentTarget).attr('href');

			this.selectTab(target);
			this.saveTabSelection(target);
		},

		/**
		 * Update the selected tab on the UI.
		 */
		selectTab: function(whichTab) {
			if (whichTab === '#dashboard-tab-my' || whichTab === '#dashboard-tab-my-monitors') {
				$('.dashboard-filter-form').hide();
			} else {
				$('.dashboard-filter-form').show();
			}

			if (this.$(whichTab + '-btn').length > 0) {
				this.$(whichTab + '-btn').tab('show');
				this.$(whichTab).addClass('active');
			} else {
				this.$('.nav-tabs li').first().tab('show');
				this.$('div[id^="dashboard-tab-"]').first().addClass('active');
			}
		},

		/**
		 * Persist the sort order of the widgets within the specified container.
		 */
		saveWidgetOrder: function(list) {
			var sortData = $(list).sortable('serialize', {
				attribute: 'data-id',
				expression: '(.+)[_](.+)'
			});

			App.user.saveUserPreference(this.model.get('id') + '-' + $(list).attr('id') + '-widgets', sortData);
		},

		/**
		 * Retrieve the saved sort order for the widgets within the specified container (if present).
		 */
		getWidgetOrder: function(list) {
			var sortData = App.user.getUserPreference(this.model.get('id') + '-' + $(list).attr('id') + '-widgets');
			return sortData;
		},

		/**
		 * Sort the widgets in all available widget containers
		 */
		sortWidgets: function() {
			var self = this;
			_.each($(this.ui.myWidgetsContainer).children(), function(list) {
				self.sortWidgetsByContainer(list);
			});
		},

		/**
		 * Attempt to sort the widgets for the specified container using saved preferences (if present).
		 */
		sortWidgetsByContainer: function(list) {
			var widgetOrder = this.getWidgetOrder(list);

			if (widgetOrder && $(list).children().length > 1) {
				$(list).children().sort(function(a, b) {
					if (widgetOrder.indexOf(a.id) > widgetOrder.indexOf(b.id)) {
						return 1;
					} else if (widgetOrder.indexOf(a.id) < widgetOrder.indexOf(b.id)) {
						return -1;
					}

					return 0;
				}).detach().appendTo(list);
			}
		},

		/**
		 * Persist the selected tab in local storage so we can remember the user's selection
		 */
		saveTabSelection: function(whichTab) {
			store.set(this.model.get('id'), whichTab);
		},

		/**
		 * Retrieve the saved tab selection for this domain (if it exists).
		 */
		getSavedTabSelection: function() {
			var savedTab = store.get(this.model.get('id'));
			if (!savedTab) {
				savedTab = '#dashboard-tab-my-widgets';
			}
			this.selectTab(savedTab);
		},

		getDashboardName: function() {
			return this.model.get('name');
		},

		getDashboardDescription: function() {
			return this.model.get('description');
		},

		isPublic: function() {
			return !this.model.get('isPrivate');
		},

		isNotOwner: function() {
			return (this.model.get('owner') !== App.user.getUsername());
		},

		getReportOwner: function() {
			return this.model.get('owner');
		},

		serializeData: function() {
			return this;
		},

		createWidget: function() {
			this.createReport('widget');
		},

		createReport: function(type) {
			// ask for the domain selected
			this.CreateReportDialogView = new CreateReportDialogView({
				className: 'modal-create-report',
				dashboardId: this.model.get('id')
			});

			var reportType = type === 'widget' ? 'widget' : 'report';
			var self = this;
			this.listenTo(this.CreateReportDialogView, 'create-report', function(domainId, dashboardId) {
				self.navigateTo('domains/' + domainId + '/dashboards/' + dashboardId + '/type/' + reportType + '/new-report');
				dialog.close();
			});
			this.listenTo(this.CreateReportDialogView, 'import-report', function(report) {
				self.navigateTo('/domains/' + report.getDomainId() + '/unsaved-report/' + report.cid);
				dialog.close();
			});
			dialog.open(this.CreateReportDialogView, 'Create Report');
		},

		createMonitor: function() {
			this.CreateMonitorDialogView = new CreateMonitorDialogView({
				className: 'modal-create-report',
				dashboardId: this.model.get('id')
			});
			var self = this;
			this.listenTo(this.CreateMonitorDialogView, 'create-monitor', function(domainId, dashboardId) {
				self.navigateTo('domains/' + domainId + '/dashboards/' + dashboardId + '/new-monitor');
				dialog.close();
			});

			dialog.open(this.CreateMonitorDialogView, 'Create Monitor');
		}
	});
});

